var TreeNode = require("./treeNode.js");
var mixin = require("./src/general.js").mixin;
var ObservableTreeNode = require("./src/observable/tree/observableTreeNode.js");
var JsonParser = require("./src/datamodel/jsonParser.js");

var Model = function () {
    this.makeObservableTreeNode();

    this.makeTreeNode();

    this.submodel = this.map("submodel", true); // TODO: use children
    this.children = this.submodel;

    // scope on which this extension should focus (events etc.)
    this.scope = this.value("scope", true, function(scope) {    // TODO: shouldn't be a model field!
        console.assert(scope.search(/\$/)==-1, "No $ allowed in scope: "+scope);
        return true;
    });
};
mixin(Model, ObservableTreeNode, TreeNode);
JsonParser.registerClass(Model, "Model");

module.exports = Model;
